module.exports = __webpack_public_path__ + "static/media/rackham04full.a6909212.jpg";